import { type GetServerSideProps } from 'next';
import React from 'react';

import CoachPage, {
  getServerSideProps as coachPageGetServerSideProps,
  type CoachPageProps,
  type QueryType,
} from '../../../components/coach/CoachPage';

const Coach: React.FC<CoachPageProps> = (props) => {
  return <CoachPage {...props} />;
};

export const getServerSideProps: GetServerSideProps<CoachPageProps, QueryType> =
  coachPageGetServerSideProps;

export default Coach;
